import { render, staticRenderFns } from "./Travelerlist.vue?vue&type=template&id=12f746c5&scoped=true"
import script from "./Travelerlist.vue?vue&type=script&lang=js"
export * from "./Travelerlist.vue?vue&type=script&lang=js"
import style0 from "./Travelerlist.vue?vue&type=style&index=0&id=12f746c5&prod&lang=css"
import style1 from "./Travelerlist.vue?vue&type=style&index=1&id=12f746c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f746c5",
  null
  
)

export default component.exports